import {
    escapePrintViewText,
    replaceMediaLikeTagsWithIds,
} from '@/common/questionPrintView/shared'

const sortingItemText = (item) => {
    if (!item) {
        return ''
    }

    if (item.type === 'image' && item.related_media_id) {
        return `image media id: ${escapePrintViewText(item.related_media_id)}`
    }

    if (item.text) {
        return escapePrintViewText(item.text)
    }

    return ''
}

const buildSortingQuestionPrintView = (content) => {
    const questionHtml = replaceMediaLikeTagsWithIds(content.question || '')
    const itemsHtml = (content.options || [])
        .map((item, index) => {
            const itemText = sortingItemText(item)

            if (!itemText) {
                return ''
            }

            return `<p>${index + 1}. ${itemText}</p>`
        })
        .filter(Boolean)
        .join('')

    return `${questionHtml}${itemsHtml}`
}

export {buildSortingQuestionPrintView}
